module.exports = __webpack_public_path__ + "media/images/vertical-0c3ee4dae946b14298e82344a8e57d40.png";